import * as DataDogLogs from '~/lib/datadog/datadog';

/**
 * Replaces placeholders like {key} in a template string with corresponding values.
 * If a key in the placeholder is not found in the values object, the placeholder remains unchanged.
 * @param {string} template The template string with placeholders (e.g., "Hello {name}").
 * @param {object} values An object mapping keys to their replacement values (e.g., { name: "World" }).
 * @returns {string} The substituted string.
 */
export const substitute = (template, values) => {
  if (typeof template !== 'string') {
    DataDogLogs.warn(
      '[Allbirds utils] - substitute - template is not a string',
      { template, values },
      new Error('template is not a string'),
    );
    return '';
  }
  if (typeof values !== 'object' || values === null) {
    DataDogLogs.warn(
      '[Allbirds utils] - substitute - values is not an object',
      { values },
      new Error('values is not an object'),
    );
    return template;
  }

  return template.replace(/{(\w+)}/g, (placeholder, key) => {
    const hasKey = Object.prototype.hasOwnProperty.call(values, key);
    return hasKey ? values[key] : placeholder;
  });
};
